import React, { useContext, useEffect } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import logo from "../../assets/img/logo.png";
import BienvenidoPanelLiquidaciones from "../../components/comunes/BienvenidoPanelLiquidaciones";
import TituloPagina from "../../components/comunes/TituloPagina";
import Footer from "../../components/comunes/Footer";
import TablaTasasZocoAdmin from "../../components/administracion/TablaTasasZocoAdmin";
import { getToken } from "../../utils/auth";


const LiquidacionesTasasZoco = () => {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const apiUrlToken = process.env.REACT_APP_API_TOKEN;

    useEffect(() => {
        const verificarToken = async () => {
            const token = getToken();

            if (!token) {
                manejarRespuestaNoAutorizada();
                return;
            }

            try {
                const response = await fetch(apiUrlToken, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });

                if (!response.ok) {
                    if (response.status === 401) {
                        manejarRespuestaNoAutorizada();
                        return;
                    }

                    throw new Error("Respuesta no satisfactoria del servidor");
                }

                const data = await response.json();
                if (data !== 2) {
                    manejarAccesoDenegado();
                }
            } catch (error) {
                console.error("Error al validar el token", error);
            }
        };

        const redireccionar = () => {
            navegacion("/");
            window.location.reload();
        };

        const manejarRespuestaNoAutorizada = () => {
            sessionStorage.removeItem("token");
            Swal.fire({
                title: "Sesion expirada o token invalido.",
                text: "Inicie sesion nuevamente.",
                imageUrl: logo,
                imageWidth: 100,
                imageHeight: 30,
                imageAlt: "Logo",
                confirmButtonText: "Ok",
                timer: 5000,
                allowOutsideClick: true,
                customClass: {
                    container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                    confirmButton: "my-swal-button",
                },
            }).then(redireccionar);
        };

        const manejarAccesoDenegado = () => {
            Swal.fire({
                title: "Acceso denegado.",
                text: "No tiene permisos para acceder.",
                imageUrl: logo,
                imageWidth: 100,
                imageHeight: 30,
                imageAlt: "Logo",
                confirmButtonText: "Ok",
                timer: 5000,
                allowOutsideClick: true,
                customClass: {
                    container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                    confirmButton: "my-swal-button",
                },
            }).then(redireccionar);
        };

        verificarToken();
    }, [apiUrlToken, darkMode, navegacion]);

    return (
        <div translate="no" className="d-flex flex-column min-vh-100">
            <div className="py-5">
                <BienvenidoPanelLiquidaciones />
            </div>
            <div className="pt-2">
                <TituloPagina title="Tasas Zoco" />
            </div>
            <div className="container py-4">
                <TablaTasasZocoAdmin />
            </div>
            <div className="py-4 mt-auto">
                <Footer />
            </div>
        </div>
    );
};

export default LiquidacionesTasasZoco;
